export function CloseIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clip-path='url(#clip0_227_8152)'>
        <path
          d='M7.43 6L11.7 1.72C12.1 1.33 12.1 0.69 11.7 0.3C11.31 -0.1 10.67 -0.1 10.28 0.3L6 4.57L1.72 0.3C1.33 -0.1 0.69 -0.1 0.3 0.3C-0.1 0.69 -0.1 1.33 0.3 1.72L4.57 6L0.3 10.28C-0.1 10.67 -0.1 11.31 0.3 11.7C0.69 12.1 1.33 12.1 1.72 11.7L6 7.43L10.28 11.7C10.67 12.1 11.31 12.1 11.7 11.7C12.1 11.31 12.1 10.67 11.7 10.28L7.43 6Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_227_8152'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>

  )
}
